// React for Website

import React, { useState } from "react";
//outsource
import { Form, Checkbox, Row } from "antd";

//components

const UserDetailRoster = ({ disabled }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Row>
      <Form.Item name="shopRoster" valuePropName="checked" initialValue={false}>
        <Checkbox disabled={disabled}>Shop Roster</Checkbox>
      </Form.Item>
      <Form.Item
        name="individualRoster"
        valuePropName="checked"
        initialValue={false}
      >
        <Checkbox disabled={disabled} style={{ paddingLeft: 40 }}>
          Individual Roster
        </Checkbox>
      </Form.Item>
    </Row>
  );
};

export default UserDetailRoster;
